import {
  MdsCarouselItem,
  MdsItem,
  MdsItemListSize,
} from "@/design-system/components/item-list/types";
import { CollectionObservable } from "@/store/collections/CollectionObservable";
import { INoteObservable } from "@/store/note";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { SessionObservable } from "@/store/sessions/SessionObservable";
import { ReactNode } from "react";
import { MDSRowItemSize } from "@/mds";

export enum MdsItemListRowType {
  Skeleton = "Skeleton",
  Carousel = "Carousel",
  Item = "Item",
  SectionHeader = "SectionHeader",
  Padding = "Padding",
  AsyncNote = "AsyncNote",
  AsyncCollection = "AsyncCollection",
  AsyncTemplate = "AsyncTemplate",
  AsyncSession = "AsyncSession",
  Other = "Other",
}

interface IMdsItemListRowData {
  type: MdsItemListRowType;
  key: string;
  payload: { [key: string]: unknown };
}

export interface MdsItemListAsyncNoteRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.AsyncNote;
  size?: MdsItemListSize;
  payload: {
    noteId: string;
    itemRow: MdsItemListItemRowData | ((note: INoteObservable) => MdsItemListItemRowData);
  };
}

export interface MdsItemListAsyncCollectionRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.AsyncCollection;
  size?: MdsItemListSize;
  payload: {
    collectionId: string;
    itemRow:
      | MdsItemListItemRowData
      | ((collection: CollectionObservable) => MdsItemListItemRowData);
  };
}

export interface MdsItemListAsyncTemplateRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.AsyncTemplate;
  size?: MdsItemListSize;
  payload: {
    templateId: string;
    itemRow: MdsItemListItemRowData | ((template: TemplateObservable) => MdsItemListItemRowData);
  };
}

export interface MdsItemListAsyncSessionRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.AsyncSession;
  size?: MdsItemListSize;
  payload: {
    sessionId: string;
    itemRow: MdsItemListItemRowData | ((session: SessionObservable) => MdsItemListItemRowData);
  };
}

export interface MdsItemListSkeletonRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.Skeleton;
  size?: MdsItemListSize;
}

export interface MdsItemListCarouselRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.Carousel;
  payload: {
    items: MdsCarouselItem[];
  };
}

export interface MdsItemListItemRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.Item;
  payload: MdsItem;
  size?: MDSRowItemSize;
  mustClickOnRowTitle?: boolean;
}

export interface MdsItemListSectionHeaderRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.SectionHeader;
  payload: {
    title: string;
  };
}

export interface MdsItemListPaddingRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.Padding;
  payload: {
    height: number;
  };
}

export interface MdsItemListOtherRowData extends IMdsItemListRowData {
  type: MdsItemListRowType.Other;
  size?: MdsItemListSize;
  payload: {
    children: ReactNode;
  };
}

export type MdsItemListRowData =
  | MdsItemListSkeletonRowData
  | MdsItemListCarouselRowData
  | MdsItemListItemRowData
  | MdsItemListSectionHeaderRowData
  | MdsItemListPaddingRowData
  | MdsItemListAsyncNoteRowData
  | MdsItemListAsyncCollectionRowData
  | MdsItemListAsyncTemplateRowData
  | MdsItemListAsyncSessionRowData
  | MdsItemListOtherRowData;
